 // mediaManagment/sound_types

import { Media            ,
         initializedMedia } from './types';

export interface Sound extends Media
 {
  visible     : string ,
  title       : string ,
  description : string ,
  soundFile   : string ,
  fileBlob?   : Blob;    // Blob téléchargé
  objectURL?  : string;  // URL locale (via URL.createObjectURL)  
 }

export const initializedSound = (): Sound => (
 {
  ...initializedMedia()                       ,
  visible     : "" ,
  title       : "" ,
  description : "" ,
  soundFile   : "" ,
  fileBlob    : undefined,
  objectURL   : undefined,  
});
